declare global {
    interface Window {
        _env_?: Record<string, string>;
    }
}

// Reads runtime-injected config first (populated by docker-entrypoint.sh from
// the container's actual env vars at startup), falling back to the
// build-time CRA env for local dev (`yarn start`/`.env`).
export const getEnv = (key: string): string | undefined =>
    window._env_?.[key] || process.env[key];
